export default __webpack_public_path__ + "static/media/ten.2fbc22ae.svg";